@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/variables" as v;

$tagTextColor: v.$palette-gray-900;
$tagBgcActive: v.$palette-blue-light-2;
$tagTextColorActive: v.$palette-blue;

.tagListContainer {
  cursor: auto;
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  max-height: 170px;
  margin: 8px 0 0 0;
  background-color: v.$palette-white;
  border: 1px solid v.$palette-gray-300;
  box-shadow: v.$shadow-2;
  border-radius: 6px;
}

.tagList {
  margin: 0;
  padding: 4px;
  list-style: none;
}

.tag {
  cursor: pointer;
  border-radius: 5px;
  padding: 8px 12px;
  @include t.text(14px, 16px, 500);
  color: $tagTextColor;

  .addBtn {
    display: none;
  }
}

.tag.active {
  position: relative;
  background-color: $tagBgcActive;
  color: $tagTextColorActive;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .addBtn {
    display: block;
  }
}
